import { base64ToArrayBuffer } from './base64ToArrayBuffer'

export function openInNewTab(data: string, type?: string): void {
  if (!data) {
    console.warn('No data to open in a new tab.')
    return
  }

  const buffer = base64ToArrayBuffer(data)
  const file = new Blob([buffer], { type })
  const fileUrl = window.URL.createObjectURL(file)
  const _newTab = window.open(fileUrl)
}
